export const checkIsVoucher = (fields: Array<{ name: string }>, isGameKey: boolean) =>
  !isGameKey && fields.some((field) => field.name === 'id1' || field.name === 'email')
